import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Indicates the API version to use when interacting with the Primer backend. Options are:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`PrimerApiVersion.V2_3`}</inlineCode>{` - will use ApiVersion 2.3`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`PrimerApiVersion.V2_4`}</inlineCode>{` - will use ApiVersion 2.4`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`PrimerApiVersion.LATEST`}</inlineCode>{` - will use the latest available ApiVersion version`}</li>
    </ul>
    <p>{`Note that this is optional, if a value is not supplied, ApiVersion `}<inlineCode parentName="p">{`V2.4`}</inlineCode>{` will be used by default.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      